import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { DVLALookupStates }                         from './dvla-lookup.states';
import { DvlaLookupMotHistoryComponent }            from './dvla-lookup.mot-history.component';
import { DvlaLookupMotHistoryExpandedRowComponent } from './dvla-lookup.mot-history.row.expanded.component';
import { DvlaLookupService }                        from './dvla-lookup.service';
import { DvlaLookupSettingsComponent }              from './dvla-lookup.settings.component';
import { PurchaseDvlaLookupsComponent }             from './dvla-lookup.purchase.component';
import { SharedModule }                             from '../shared/shared.module';
import { TableModule }                              from '../table/table.module';

@NgModule({
  declarations: [
    DvlaLookupMotHistoryComponent,
    DvlaLookupMotHistoryExpandedRowComponent,
    DvlaLookupSettingsComponent,
    PurchaseDvlaLookupsComponent
  ],
  entryComponents: [
    DvlaLookupMotHistoryComponent,
    DvlaLookupMotHistoryExpandedRowComponent,
    DvlaLookupSettingsComponent,
    PurchaseDvlaLookupsComponent
  ],
  imports: [
    SharedModule,
    TableModule,
    UIRouterModule.forChild({ states: DVLALookupStates })
  ],
  providers: [
    DvlaLookupService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class DvlaLookupModule {}
